const GlobalBaseState = {
  isBrowser: typeof window !== "undefined"
}

export default GlobalBaseState
